import { useState } from "react";

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 769);
  const isMobileWidth = matchMedia("(max-width: 768px)");

  const handleResize = (event: MediaQueryListEvent) => {
    if (event.matches && !isMobile) {
      setIsMobile(true);
    } else if (!event.matches && isMobile) {
      setIsMobile(false);
    }
  };

  isMobileWidth.addListener(handleResize);

  return isMobile;
};

export default useIsMobile;
